/**
 * supabase-js wraps non-2xx edge function responses in a FunctionsHttpError
 * whose `.message` is the unhelpful "Edge Function returned a non-2xx status
 * code". The real, user-friendly message returned by our functions lives in
 * `error.context` (the raw Response object). This helper unwraps it.
 *
 * Mirrors the pattern from ardent-admissions.
 */
export async function readFunctionError(err: unknown): Promise<string> {
  const e = err as { name?: string; message?: string; context?: Response }
  if (e?.name === 'FunctionsHttpError' && e.context) {
    try {
      const text = await e.context.text()
      try {
        const body = JSON.parse(text)
        return body.error ?? body.message ?? text
      } catch {
        return text || e.message || 'Request failed.'
      }
    } catch {
      return e.message ?? 'Request failed.'
    }
  }
  if (e?.message) return e.message
  return 'Something went wrong.'
}
